module.exports = __webpack_public_path__ + "img/10.187cef6f.png";